export default __webpack_public_path__ + "static/media/logo-catalogo.df9caeb7.svg";